export default __webpack_public_path__ + "static/media/search.f63ecba1.svg";